import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=66783a61"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66783a61')) {
      api.createRecord('66783a61', component.options)
    } else {
      api.reload('66783a61', component.options)
    }
    module.hot.accept("./Empty.vue?vue&type=template&id=66783a61", function () {
      api.rerender('66783a61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/Empty.vue"
export default component.exports